/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Bronze_Bee_StepInputs */

const en_happy_bronze_bee_step = /** @type {(inputs: Happy_Bronze_Bee_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite data`)
};

const de_happy_bronze_bee_step = /** @type {(inputs: Happy_Bronze_Bee_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten überschreiben`)
};

/**
* | output |
* | --- |
* | "Overwrite data" |
*
* @param {Happy_Bronze_Bee_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_bronze_bee_step = /** @type {((inputs?: Happy_Bronze_Bee_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Bronze_Bee_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_bronze_bee_step(inputs)
	return de_happy_bronze_bee_step(inputs)
});